export function URLSearchParamParser(params: any) {
    let query = new URLSearchParams()
    Object.entries(params).forEach(([k, v]: [any, any]) => {
        if (Array.isArray(v)) {
            v.forEach(vv => query.append(k, vv))
        } else v && query.append(k, v)
    })

    return query.toString();
}